export const buildNumber = '20260601.4';
export const version = 'main';
export const latestCommit = '1299d143d7e396138a2a90987ecb6181c5e393a0';
